module.exports = __webpack_public_path__ + "static/media/DAPSwhitelogo.e827baf5.png";